import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/react";
import React from "react";
import { useState } from "react";
import { FaTimes } from "react-icons/fa";

function InviteCommunityModal({ open, onClose, submit }) {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");

  const close = () => {
    onClose();
  };

  const submitInvite = () => {
    let payload = { email: email };
    submit(payload);
    onClose();
  };
  return (
    <Modal className="w-full " isOpen={open} onClose={onClose} size={"md"}>
      <ModalOverlay />
      <ModalContent
        className="max-w-[479px] h-[413px] overflow-auto py-[22px] relative"
        containerProps={{
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
        }}
        borderRadius={20}
      >
        <div className="flex  px-[20px] relative items-center w-full">
          <div
            onClick={onClose}
            className="w-[36px] absolute cursor-pointer  h-[36px] float-left bg-[#ffffff] border-[.1px] rounded-full my-[rem]  justify-center flex items-center"
          >
            <FaTimes size={12} className="float-left text-[#050558]" />
          </div>

          <h4 className="text-center mx-auto text-base text-black font-[500] text-[20px]">
            Invite
          </h4>
        </div>

        <ModalBody>
          <div className="mt-[1rem] mb-[1rem] align-middle  ">
            <div className="mt-[1rem] text-left ">
              <h4 className="font-[700] text-[20px] text-[#27272e]">
                Invite community members
              </h4>
              <p className="mt-[.2rem] mb-[.5rem] font-[400] text-[#60646c] text-[14px]">
                Allow your neighbours and community get the latest happening
                going on and also share information on the community.
              </p>
              <label className=" font-[500] text-base font-base text-[14px] text-[#0a0d14]">
                Email Address
              </label>
              <input
                type="email"
                placeholder="Hello@gmail.com"
                required
                onChange={(e) => setEmail(e.target.value)}
                className=" text-[#888d98] outline-none rounded-[10px] border-[1px]  border-[#02023414]  w-full  mb-[1rem] text-left py-[10px] px-[12px]"
              />
              <div className="flex justify-end gap-[4px] cursor-pointer absolute bottom-[22px] right-[22px]">
                <button
                  disabled={loading ? true : false}
                  onClick={close}
                  className="bg-transparent w-[93px] h-[40px]  text-[14px] border-[1px] border-[#e2e4e9] font-[500] text-[#525866] text-center rounded-[10px]  py-[px] px-[20px]"
                >
                  Cancel
                </button>
                <button
                  disabled={!email ? true : false}
                  onClick={submitInvite}
                  className="bg-[#f04438] font-[500] text-white w-[84px] h-[40px] cursor-pointer  text-center rounded-[10px] py-[px] px-[20px]"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default InviteCommunityModal;
